import React, { useState } from 'react';
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Toast,
  ToastContainer,
  Spinner,
  Tabs,
  Tab,

  Badge,
} from 'react-bootstrap';
import {
  PersonCircle,
  Envelope,
  Telephone,
  Shield,
  Save,
  Pencil,
  Camera,
  CheckCircle,
} from 'react-bootstrap-icons';
import { useAuth } from '../contexts/AuthContext';

const ProfilePage = () => {
  const { user, login } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || '+241 01 23 45 67',
    role: user?.role || 'patient',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });

  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 4000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    setLoading(true);
    setTimeout(() => {
      // Simuler une mise à jour du profil
      const updatedUser = { ...user, ...formData };
      login(updatedUser);
      showToast('Profil mis à jour avec succès', 'success');
      setEditMode(false);
      setLoading(false);
    }, 800);
  };

  return (
    <div className="" style={{ fontFamily: "'Inter', sans-serif" }}>
      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        <Toast show={toast.show} onClose={() => setToast((prev) => ({ ...prev, show: false }))} bg={toast.variant} delay={4000} autohide>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">
              {toast.variant === 'success' ? 'Succès' : toast.variant === 'danger' ? 'Erreur' : 'Information'}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="container-fluid">
        {/* En-tête */}
        <div className="mb-4">
          <h4 className="main-title mb-0 d-flex align-items-center gap-2">
            <div className="bg-primary bg-opacity-10 rounded-circle p-2">
              <PersonCircle size={24} className="text-primary" />
            </div>
            Mon profil
          </h4>
          <p className="text-muted mb-0 mt-1">
            Consultez et modifiez vos informations personnelles
          </p>
        </div>

        <Row>
          <Col md={12}>
            <Card className="border-0 shadow-sm" style={{ borderRadius: '20px', overflow: 'hidden' }}>
              <div className="p-4" style={{ background: 'linear-gradient(135deg, #4361ee 0%, #3b2a9f 100%)' }}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 fw-semibold text-white d-flex align-items-center gap-2">
                    <PersonCircle size={20} />
                    Informations personnelles
                  </h5>
                  {!editMode ? (
                    <Button variant="light" size="sm" onClick={() => setEditMode(true)} className="rounded-pill px-3">
                      <Pencil size={14} className="me-1" /> Modifier
                    </Button>
                  ) : (
                    <Button variant="light" size="sm" onClick={() => setEditMode(false)} className="rounded-pill px-3">
                      Annuler
                    </Button>
                  )}
                </div>
              </div>
              <Card.Body className="p-4">
                <Row className="g-4">
                  <Col md={4} className="text-center">
                    <div className="position-relative d-inline-block">
                      <div style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        border: '4px solid #fff',
                        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                        margin: '0 auto',
                        background: '#f0f0f0',
                      }}>
                        <img
                          src="https://randomuser.me/api/portraits/men/1.jpg"
                          alt="Avatar"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                      <div className="position-absolute bottom-0 end-0 bg-primary rounded-circle p-2" style={{ transform: 'translate(10%, 10%)' }}>
                        <Camera size={16} className="text-white" />
                      </div>
                    </div>
                    <div className="mt-3">
                      <Badge bg="success" className="rounded-pill px-3 py-2">
                        <CheckCircle size={12} className="me-1" /> Compte vérifié
                      </Badge>
                    </div>
                  </Col>
                  <Col md={8}>
                    <Form>
                      <Row className="g-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Nom complet</Form.Label>
                            {editMode ? (
                              <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                              />
                            ) : (
                              <p className="fw-semibold">{formData.name}</p>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Rôle</Form.Label>
                            {editMode ? (
                              <Form.Select name="role" value={formData.role} onChange={handleChange}>
                                <option value="patient">Patient</option>
                                <option value="doctor">Médecin</option>
                                <option value="pharmacist">Pharmacien</option>
                                <option value="admin">Administrateur</option>
                              </Form.Select>
                            ) : (
                              <p className="fw-semibold">
                                {formData.role === 'patient' && 'Patient'}
                                {formData.role === 'doctor' && 'Médecin'}
                                {formData.role === 'pharmacist' && 'Pharmacien'}
                                {formData.role === 'admin' && 'Administrateur'}
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Email</Form.Label>
                            {editMode ? (
                              <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                              />
                            ) : (
                              <p className="fw-semibold">{formData.email}</p>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Téléphone</Form.Label>
                            {editMode ? (
                              <Form.Control
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                              />
                            ) : (
                              <p className="fw-semibold">{formData.phone}</p>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      {editMode && (
                        <div className="mt-4 d-flex justify-content-end">
                          <Button
                            variant="primary"
                            onClick={handleSave}
                            disabled={loading}
                            className="rounded-pill px-4"
                          >
                            {loading ? <Spinner size="sm" className="me-1" /> : <Save size={16} className="me-1" />}
                            {loading ? 'Enregistrement...' : 'Enregistrer'}
                          </Button>
                        </div>
                      )}
                    </Form>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
          .card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 20px -8px rgba(0, 0, 0, 0.15) !important;
          }
        `}</style>
      </div>
    </div>
  );
};

export default ProfilePage;